import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getProjectDetails = createAsyncThunk(`illustoProject/getProjectDetails`, async (payload) => {
  try {
    const response = await magnifiAPI.getProjectDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getProjectProgress = createAsyncThunk(`illustoProject/getProjectProgress`, async (payload) => {
  try {
    const response = await magnifiAPI.getProjectDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const studioDownloadVttsAsZip = createAsyncThunk("illustoProject/studioDownloadVttsAsZip", async (payload) => {
  try {
    const response = await magnifiAPI.studioDownloadVttsAsZip(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
